<template>
  <div>
    <v-card-title>
      Histórico de alterações
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :loading="table.loading"
      :headers="table.headers"
      :items="table.data"
      :items-per-page="logs && logs.meta ? parseInt(logs.meta.per_page) : 0"
      hide-default-footer
      :page.sync="table.page"
      :options.sync="table.options"
      :sort-by.sync="table.sortBy"
      :sort-desc.sync="table.sortDesc"
      class="elevation-1"
    >
      <template v-slot:footer>
        <v-pagination
            v-model="table.page"
            :length="logs && logs.meta ? logs.meta.last_page : 0"
        ></v-pagination>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LocationHistoricTab',
  data() {
    return {
      table: {
        data: [],
        loading: false,
        filters: {
          account: '',
          search: '',
        },
        headers: [
          {
            text: 'Usuário',
            align: 'start',
            value: 'user_name'
          },
          { text: 'Ação', value: 'action' },
          {
            text: 'Data',
            value: 'created_at'
          }
        ],
        page: 1,
        limit: 15,
        sortBy: null,
        sortDesc: false,
        options: {},
      }
    }
  },
  mounted() {
    this.getLogs()
  },
  computed: {
    ...mapState({
      logs: (state) => state.locations.logs,
      location: (state) => state.locations.location,
    })
  },
  methods: {
    getLogs: async function() {
      this.table.loading = true
      await this.$store.dispatch('locations/getLogs', {
        location_name: this.location_name,
        limit: this.table.limit,
        sort: this.table.sortBy,
        desc: this.table.sortDesc,
        page: this.table.page,
      }).catch(() => {
        this.table.loading = false
      })
      this.table.loading = false
    }
  },
  watch: {
    'table.options': function (options) {
      let sortBy = options.sortBy[0]
      const sortDesc = options.sortDesc[0]
      if ((sortBy || '').includes('formatted')) {
        const s = sortBy.split('_formatted')
        sortBy = s[0]
      }

      this.table.sortBy = sortBy
      this.table.sortDesc = sortDesc
      this.table.page = options.page
      this.table.limit = 10
      this.getLogs()
    },
    'table.page': function () {
      this.getLogs()
    },
    logs: function(data) {
      this.table.data = data && Array.isArray(data.data) ? data.data : []
    },
    location: function() {
      this.getLogs()
    }
  }
};
</script>

<style scoped></style>
